import { type FunctionComponent, useCallback, useEffect } from 'react';
import cx from 'classnames';

import { Analytics } from '@trello/atlassian-analytics';
import { getScreenFromUrl } from '@trello/marketing-screens';
import { useSharedStateSelector } from '@trello/shared-state';
import { workspaceState } from '@trello/workspaces';

import { useHasReverseTrialExperience } from './useHasReverseTrialExperience';

import styles from './PremiumLozenge.less';

interface PremiumLozengeProps {
  className?: string;
  featureHighlighted?: string;
}

export const PremiumLozenge: FunctionComponent<PremiumLozengeProps> = ({
  className,
  featureHighlighted,
}) => {
  useEffect(() => {
    if (featureHighlighted) {
      Analytics.sendOperationalEvent({
        action: 'rendered',
        actionSubject: 'reverseTrialPremiumLozenge',
        source: getScreenFromUrl(),
        attributes: {
          featureHighlighted,
        },
      });
    }
  }, [featureHighlighted]);
  return (
    <div className={cx(styles.PremiumLozenge, className)}>
      <span className={styles.premiumLozengeText}>premium</span>
    </div>
  );
};

export const MaybePremiumLozenge: FunctionComponent<PremiumLozengeProps> = ({
  ...args
}) => {
  const workspaceId =
    useSharedStateSelector(
      workspaceState,
      useCallback((state) => state.workspaceId, []),
    ) || '';

  const hasReverseTrialExperience = useHasReverseTrialExperience(workspaceId);

  return hasReverseTrialExperience ? <PremiumLozenge {...args} /> : null;
};
